import * as React from "react";
import { Modal } from "antd";

interface aboutModalProps {
  visible: boolean;
  afterClose: () => void;
}

const AboutModal: React.FC<aboutModalProps> = ({ visible, afterClose }) => {
  return (
    <Modal
      title="关于"
      footer={null}
      width={300}
      onCancel={afterClose}
      visible={visible}
      centered
    >
      <p>视频会议 版权所有 2022</p>
    </Modal>
  );
};

export default AboutModal;
